import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { EyeInvisibleOutlined, EyeOutlined, LoadingOutlined, LockOutlined, ReloadOutlined, UserOutlined } from '@ant-design/icons';
import { BackendAPI } from '../../../axios';
//import UserHeader from '../UserHeader';
import { Content, Footer } from 'antd/es/layout/layout';
//import Sider from 'antd/es/layout/Sider';
//import UserNavbar from '../UserNavbar';
import { useNavigate } from 'react-router-dom';
import type { CSSProperties } from 'react';

const MySwal = withReactContent(Swal);

const overlayStyle: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
};

function ChangePasswordFirstTime() {
    const navigate = useNavigate();
    const [captchaImage, setCaptchaImage] = useState('');
    const [captchaText, setCaptchaText] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isOnClickSlider, setOnclickSlider] = useState(false);
    const [refreshToken, setRefreshToken] = useState('');
    const [loading, setLoading] = useState(false);
    const labelStyle = {
        fontWeight: "bold",
        // padding: '0 10px',
        fontSize: '16px',
        // marginBottom: "8px",
    };
    const validationSchema = Yup.object().shape({
        cpassword: Yup.string().required('Current password is required'),
        npassword: Yup.string().required('New password is required'),
        ncpassword: Yup.string()
            .required('Confirm password is required')
            .oneOf([Yup.ref('npassword')], 'Confirm password must match new password'),
        captcha: Yup.string()
            .required('Captcha is required')
            .test(
                'captcha-matches',
                'Incorrect captcha',
                (value) => value === captchaText
            ),
    });
    const { control, watch, handleSubmit, formState: { errors, touchedFields, isSubmitted } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
    });
    const handleLogout = async () => {
        try {
            const response = await BackendAPI.post("/user/logout", {}, { withCredentials: true });

            if (response.status === 200) {
                localStorage.removeItem("authToken");
                localStorage.removeItem("initialTime");
                localStorage.removeItem("lastSavedTime");
                localStorage.removeItem("remainingTime");
                navigate("/");
            }
        } catch (error) {
        }
    };
    const onSubmit = async (data: any) => {
        setLoading(true);

        console.log("Form submitted");

        const url = "/user/updatePassword";

        const requestBody = {
            password: data.npassword,
            oldpassword: data.cpassword,
        };

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${refreshToken}`,
            },
        };

        try {
            const response = await BackendAPI.post(
                url,
                requestBody,
                config
            );

            console.log("Response from server:", response.data);

            if (response.data === "successtosendmail") {

                MySwal.fire({
                    icon: "success",
                    title: "Password Updated!",
                    text: "Your password has been changed successfully. Please check your email for confirmation.",
                    confirmButtonText: "OK",
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleLogout();
                    }
                });

            } else if (
                response.data === "The current password entered is incorrect"
            ) {

                MySwal.fire({
                    icon: "error",
                    title: "Incorrect Password!",
                    text: "The current password you entered is incorrect. Please try again.",
                });

            } else if (
                response.data === "Old Password and New Password is same"
            ) {

                MySwal.fire({
                    icon: "warning",
                    title: "Password Not Changed",
                    text: "Your new password cannot be the same as your old one. Please choose a different password.",
                });

            } else if (response.data === "failtosendmail") {

                MySwal.fire({
                    icon: "warning",
                    title: "Password Updated",
                    text: "Your password was updated successfully, but we were unable to send the confirmation email. Please check your email settings or contact support if the issue persists.",
                    confirmButtonText: "OK",
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleLogout();
                    }
                });

            } else {

                MySwal.fire({
                    icon: "error",
                    title: "Error",
                    text: "An unexpected error occurred. Please try again later.",
                });
            }

        } catch (error) {

            console.error("Password update failed:", error);

            MySwal.fire({
                icon: "error",
                title: "Error",
                text: "An unexpected error occurred. Please try again later.",
            });

        } finally {
            setLoading(false);
        }
    };


    const getRefreshToken = async () => {
        try {
            const response = await BackendAPI.get("/user/refresh-token", { withCredentials: true });
            setRefreshToken(response.data);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    window.location.reload();
                }
            }
        }
    };
    useEffect(() => {
        const executeFunctions = async () => {
            await fetchCaptchaImage();
            await getRefreshToken();
        };
        executeFunctions();
    }, []);

    const fetchCaptchaImage = async () => {
        const header = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        const url = `/user/generate`;
        try {
            const response = await BackendAPI.get(url, header);
            //   const result = response.data;
            setCaptchaImage(response.data.base64Image);
            setCaptchaText(response.data.captchaText);
        } catch (error) {
            console.error('Error fetching total count:', error);
        }
    };

    return (
        <>
            <Card style={{ padding: '0px', minHeight: 360, justifySelf: 'center', borderRadius: '8px', width: '100%', border: 'none' }}>
                <Form className='login-form-modal' layout="vertical" autoComplete="off" onFinish={handleSubmit(onSubmit)} style={{ userSelect: 'none' }}>
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <h1 style={{ margin: '5px', }}>Change Password</h1>
                    </div>
                    <Col xs={24} md={12}>
                    </Col>
                    <Row>
                        <Col xs={22} md={22}>
                            <Form.Item
                                label={<span style={labelStyle}> Current Password</span>}
                                validateStatus={errors.cpassword ? 'error' : ''}
                                help={(touchedFields.cpassword || isSubmitted) && errors.cpassword ? errors.cpassword.message : ''}
                            >
                                <Controller
                                    name="cpassword"
                                    control={control}
                                    render={({ field }) =>
                                        <div style={{ position: 'relative' }}><Input prefix={<LockOutlined style={{ fontSize: '18px' }} />} type={showPassword ? 'text' : 'password'} {...field} style={{ height: '40px', borderRadius: '6px 0 0 6px', borderRight: 'none', }} className="custom-placeholder" placeholder='Enter Current Password' autoComplete="new-password" /></div>}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={2} md={2} style={{ height: '31px', alignSelf: 'center' }}>
                            <Button type='text' style={{ borderRadius: '0 10px 10px 0', border: 'none', height: '40px', background: '#1677ff', color: 'white', }}
                                tabIndex={0}
                                onClick={() => setShowPassword((prev) => !prev)}
                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                            >
                                {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                            </Button>
                        </Col>
                        <Col xs={22} md={22}>
                            <Form.Item
                                label={<span style={labelStyle}> New Password</span>}
                                validateStatus={errors.npassword ? 'error' : ''}
                                help={(touchedFields.npassword || isSubmitted) && errors.npassword ? errors.npassword.message : ''}
                            >
                                <Controller
                                    name="npassword"
                                    control={control}
                                    render={({ field }) =>
                                        <div style={{ position: 'relative' }}>
                                            <Input prefix={<LockOutlined style={{ fontSize: '18px' }} />} type={showPassword ? 'text' : 'password'} {...field} style={{ height: '40px', borderRadius: '6px 0 0 6px', borderRight: 'none', }} className="custom-placeholder" placeholder='Enter New Password' autoComplete="new-password" /></div>}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={2} md={2} style={{ height: '31px', alignSelf: 'center' }}>
                            <Button type='text' style={{ borderRadius: '0 10px 10px 0', border: 'none', height: '40px', background: '#1677ff', color: 'white', }}
                                tabIndex={0}
                                onClick={() => setShowPassword((prev) => !prev)}
                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                            >
                                {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                            </Button>
                        </Col>
                        <Col xs={22} md={22}>
                            <Form.Item
                                label={<span style={labelStyle}> Confirm Password</span>}
                                validateStatus={errors.ncpassword ? 'error' : ''}
                                help={(touchedFields.ncpassword || isSubmitted) && errors.ncpassword ? errors.ncpassword.message : ''}
                            >
                                <Controller
                                    name="ncpassword"
                                    control={control}
                                    render={({ field }) =>
                                        <div style={{ position: 'relative' }}><Input prefix={<LockOutlined style={{ fontSize: '18px' }} />} type={showPassword ? 'text' : 'password'} {...field} style={{ height: '40px', borderRadius: '6px 0 0 6px', borderRight: 'none', }} className="custom-placeholder" placeholder='Enter New Password' autoComplete="new-password" /></div>}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={2} md={2} style={{ height: '31px', alignSelf: 'center' }}>
                            <Button type='text' style={{ borderRadius: '0 10px 10px 0', border: 'none', height: '40px', background: '#1677ff', color: 'white', }}
                                tabIndex={0}
                                onClick={() => setShowPassword((prev) => !prev)}
                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                            >
                                {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                            </Button>
                        </Col>
                    </Row>

                    <Row gutter={[8, 8]}>
                        <Col xs={12} md={12} lg={12}>
                            <Row className='captcha-container'>
                                <Col xs={18} sm={18} md={18} lg={18} style={{ marginBottom: '16px' }}>
                                    <Card style={{ padding: '0px', borderRadius: '6px 0 0 6px', borderRight: 'none' }} >
                                        {/* <img src={logo} alt="CAPTCHA" style={{ width: '100%', height: '60px', objectFit: 'contain' }} /> */}
                                        <img src={`data:image/png;base64,${captchaImage}`} alt="CAPTCHA" style={{ width: '80%', height: '33px', }} />
                                    </Card>
                                </Col>
                                <Col xs={2} md={2} style={{ alignSelf: 'center', bottom: '8px', }}>
                                    <Button type='text' style={{ borderRadius: '0 10px 10px 0', border: 'none', height: '40px', background: '#1677ff', color: 'white', }}
                                        tabIndex={0} onClick={fetchCaptchaImage}
                                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                                    >
                                        <ReloadOutlined />
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} md={12} lg={12}>
                            <Row >
                                <Col xs={24} sm={24} md={24} lg={24}>
                                    <Form.Item
                                        // label={<span style={labelStyle}>Captcha</span>}
                                        validateStatus={errors.captcha ? 'error' : ''}
                                        help={(touchedFields.captcha || isSubmitted) && errors.captcha ? errors.captcha.message : ''}
                                    >
                                        <Controller
                                            name="captcha"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter Captcha' />}
                                        />
                                    </Form.Item>
                                </Col>

                            </Row>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'center' }}>
                            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </>
    )
};

export default ChangePasswordFirstTime
